import { getConfig } from '@klpkonsern/appconfig';
import { IconName } from '@klp/design/Illustrations';
import { SidebarMenuItem } from '@klp/layout/Sidebar/classes/SidebarMenuItem';
import { generateRoute } from '@klpkonsern/routing';
import type { Bruker } from '@klp/user';
export const ProjectModuleName = 'project';
const ProjectReport = 'report';
const ProjectSchema = 'schema';

export const ProjectDxboFrameAccess = (user: Bruker | undefined): boolean =>
    Boolean(user?.isAdmin);

export const ProjectRoutes = {
    projectReport: () => generateRoute([ProjectModuleName, ProjectReport]),
    projectSchema: () => generateRoute([ProjectModuleName, ProjectSchema]),
};

export const ProjectMenuItems = [
    new SidebarMenuItem({
        route: ProjectRoutes.projectReport(),
        matchRoute: ProjectRoutes.projectReport(),
        icon: IconName.GRAPH,
        translation: 'project.menuItems.report',
        access: ProjectDxboFrameAccess,
    }),
];

export const ProjectSchemaMenuItems = [
    new SidebarMenuItem({
        route: ProjectRoutes.projectSchema(),
        matchRoute: ProjectRoutes.projectSchema(),
        icon: IconName.EDIT,
        translation: 'project.menuItems.schema',
        access: ProjectDxboFrameAccess,
    }),
];

export const PowerBiProjectDxboURL = () =>
    getConfig('WEBAPP_POWER_BI_PROJECTDXBO_URL');
